export enum Module {
  TenantRegistration = "tenantRegistration",
  Legal = "legal",
}
